export enum GameViewSource {
  Dashboard = 1,
  GamesPage = 2,
}

